export default __webpack_public_path__ + "static/media/ceramol-acn3-products.a6d69b7f.jpg";